import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Footer from '../components/Footer';
//import Hero from '../components/Landing/Hero';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = {
  card: {
    minWidth: 275,
    maxWidth: 600,
    margin: '0 auto'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 24,
  },
  pos: {
    marginBottom: 12,
  },
};


class Landing extends Component {
  render() {
    const { classes } = this.props;
    const bull = <span className={classes.bullet}>•</span>;
    return (
      <div>
        <AppBar position="static">
          <Toolbar style={{flexDirection: 'row', justifyContent: 'space-between'}}>
            <Typography variant="h6" color="inherit" >
              Where's My Art?
            </Typography>
            <Typography style={{cursor: 'pointer'}} onClick={() => this.props.history.push('/login')} variant="h6" color="inherit" >
              Login
            </Typography>
          {/* <Button onClick={this.handleLogout} color="inherit">Logout</Button> */}
          </Toolbar>
        </AppBar>

        <br />
        <br />
        <br />



        {/*-- Hero  --*/}
        <Card className={classes.card}>
          <CardContent>
            <Typography className={classes.title} color="textSecondary" gutterBottom>
              Welcome to Where's My Art!
            </Typography>
            <br />
            <Typography variant="h4" component="h2">
              {bull}Upload an image to see where it can be found online.<br /><br /> 
              {bull}Stop people from claiming your work!<br /><br />
              {bull}Find out if your art or image is where its supposed to be<br /><br />
              {bull}Try it for free now!<br />
            </Typography>
          </CardContent>
          <CardActions>
            <Button onClick={() => this.props.history.push('/login')} size="large" variant="contained" color="primary">Login for 5 Free scans</Button>
          </CardActions>
        </Card>





        {/*-- Features  --*/}

        {/*-- Why  --*/}

        {/*-- Pricing  --*/}

         {/*-- Signup  --*/}


        <Footer />
      </div>
    );
  }
}

export default withStyles(styles)(Landing);